/// <amd-module name="VSS/Features/PlatformUI/Components/ContributedContent/ContributedContent" />
import * as React from "react";

import { IVssContributionService } from "VSS/Platform/Contribution";
import { useComponentContext, WrappedComponent } from "VSS/Platform/Layout";
import { css } from "VSSUI/Util";
import { IContributedContentProps } from "./ContributedContent.Props";

export function ContributedContent(props: IContributedContentProps): JSX.Element | null {
    const { className, componentProperties, contribution, contributionId, dependencies } = props;
    const componentContext = useComponentContext();

    const sharedProps = {
        ...componentProperties,
        ...contribution.componentProperties,
        className: css(
            className,
            componentProperties && componentProperties.className,
            contribution.componentProperties && contribution.componentProperties.className
        )
    };

    const allDependencies = [...(dependencies || []), ...(contribution.dependencies || [])];

    if (contribution.uri) {
        return (
            <WrappedComponent
                dependencies={allDependencies.concat(["ms.vss-web.ext-content"])}
                onDependenciesResolved={props.onDependenciesResolved}
                wrappedType="ExternalContent"
                wrappedProps={{
                    initialHandshakeData: componentProperties && componentProperties.context,
                    ...sharedProps,
                    contributionId: contributionId
                }}
            />
        );
    } else if (contribution.componentType) {
        const contributionService = componentContext.pageContext.getService<IVssContributionService>("IVssContributionService");
        if (contributionService.isContributionTrusted(contributionId)) {
            return (
                <WrappedComponent
                    dependencies={allDependencies}
                    onDependenciesResolved={props.onDependenciesResolved}
                    wrappedType={contribution.componentType}
                    wrappedProps={sharedProps}
                />
            );
        }
    }

    return null;
}
